import * as React from 'react';
import type { SVGProps } from 'react';
const Svg3DotsBounce = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={24} height={24} fill='currentcolor' {...props}>
    <circle cx={4} cy={12} r={3}>
      <animate
        id='3-dots-bounce_svg__b'
        attributeName='cy'
        begin='0;a.end+0.25s'
        calcMode='spline'
        dur='0.6s'
        keySplines='.33,.66,.66,1;.33,0,.66,.33'
        values='12;6;12'
      />
    </circle>
    <circle cx={12} cy={12} r={3}>
      <animate
        attributeName='cy'
        begin='b.begin+0.1s'
        calcMode='spline'
        dur='0.6s'
        keySplines='.33,.66,.66,1;.33,0,.66,.33'
        values='12;6;12'
      />
    </circle>
    <circle cx={20} cy={12} r={3}>
      <animate
        id='3-dots-bounce_svg__a'
        attributeName='cy'
        begin='b.begin+0.2s'
        calcMode='spline'
        dur='0.6s'
        keySplines='.33,.66,.66,1;.33,0,.66,.33'
        values='12;6;12'
      />
    </circle>
  </svg>
);
export default Svg3DotsBounce;
